import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";
import { QrCode, ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setErr(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", gridTemplateColumns: "1fr", background: "#fff" }}>
      <div style={{ display: "grid", placeItems: "center", padding: 24 }}>
        <div style={{ width: "100%", maxWidth: 420 }}>
          <Link to="/" data-testid="login-back-home" className="btn btn-ghost" style={{ marginBottom: 24, padding: "6px 10px" }}>
            <ArrowLeft size={14} /> Back
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
            <div style={{ width: 32, height: 32, background: "#000", display: "grid", placeItems: "center" }}>
              <QrCode size={20} color="#fff" weight="bold" />
            </div>
            <span className="font-display" style={{ fontWeight: 900, fontSize: 20 }}>7AuraDigital</span>
          </div>
          <div className="overline" style={{ marginBottom: 8 }}>Admin Console</div>
          <h1 className="font-display" style={{ fontSize: 40, fontWeight: 900, letterSpacing: "-0.03em", margin: 0, lineHeight: 1 }}>
            Sign in.
          </h1>
          <p style={{ color: "var(--text-2)", marginTop: 12 }}>Access the QR & content management dashboard.</p>

          <form onSubmit={submit} style={{ marginTop: 28, display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <label className="label" htmlFor="email">Email</label>
              <input id="email" type="email" className="input" value={email}
                onChange={(e) => setEmail(e.target.value)} required autoComplete="username"
                placeholder="you@example.com"
                data-testid="login-email" />
            </div>
            <div>
              <label className="label" htmlFor="password">Password</label>
              <input id="password" type="password" className="input" value={password}
                onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
                placeholder="••••••••"
                data-testid="login-password" />
            </div>
            {err && <div data-testid="login-error" style={{ color: "var(--danger)", fontSize: 13 }}>{err}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}
              data-testid="login-submit" style={{ padding: "12px 16px", fontSize: 15 }}>
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
